export default "/_next/static/fonts/Graphik-Semibold-a439eb2d9f9c12509fb3dc2c79b7a5ae.woff";